import { useState } from 'react';
import GlobalSearch from '@/Pages/admin/ChargebeePortal/components/GlobalSearch';
import UserTimeline from '@/Pages/admin/ChargebeePortal/components/UserTimeline';
import WebhookInbox from '@/Pages/admin/ChargebeePortal/components/WebhookInbox';
import ReconciliationDashboard from '@/Pages/admin/ChargebeePortal/components/ReconciliationDashboard';
import FailuresAlerts from '@/Pages/admin/ChargebeePortal/components/FailuresAlerts';
import UnsyncedUsers from '@/Pages/admin/ChargebeePortal/components/UnsyncedUsers';
import { PORTAL_TABS, PORTAL_TAB_ITEMS } from '@/Pages/admin/ChargebeePortal/constants/portalUiConstants';
import '@/Pages/admin/ChargebeePortal/ChargebeeAnalyticsDashboard.css';

const ChargebeeAnalyticsDashboard = () => {
  const [activeTab, setActiveTab] = useState(PORTAL_TABS.SEARCH);
  const [selectedUserId, setSelectedUserId] = useState(null);

  const handleUserSelect = (userId) => {
    setSelectedUserId(userId);
    setActiveTab(PORTAL_TABS.TIMELINE);
  };

  const tabs = PORTAL_TAB_ITEMS;

  return (
    <div className="chargebee-portal">
      <div className="portal-header">
        <h1>Chargebee Operations Portal</h1>
        <p>Comprehensive billing operations and analytics dashboard</p>
      </div>

      <div className="portal-tabs">
        {tabs.map(tab => (
          <button
            key={tab.id}
            className={`tab-button ${activeTab === tab.id ? 'active' : ''}`}
            onClick={() => setActiveTab(tab.id)}
          >
            {tab.label}
          </button>
        ))}
      </div>

      <div className="portal-content">
        {activeTab === PORTAL_TABS.SEARCH && <GlobalSearch onUserSelect={handleUserSelect} />}
        {activeTab === PORTAL_TABS.TIMELINE && <UserTimeline userId={selectedUserId} />}
        {activeTab === PORTAL_TABS.WEBHOOKS && <WebhookInbox />}
        {activeTab === PORTAL_TABS.RECONCILIATION && <ReconciliationDashboard />}
        {activeTab === PORTAL_TABS.FAILURES && <FailuresAlerts />}
        {activeTab === PORTAL_TABS.UNSYNCED && <UnsyncedUsers />}
      </div>
    </div>
  );
};

export default ChargebeeAnalyticsDashboard;
